module.exports = __webpack_public_path__ + "img/2_43.fe1e473b.png";